import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMedicalCross: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="medical-cross, first-aid, emergency"><path d="M15.25 2C15.6642 2 16 2.33579 16 2.75V8H21.25C21.6642 8 22 8.33579 22 8.75V15.25C22 15.4489 21.9209 15.6396 21.7803 15.7803C21.6396 15.9209 21.4489 16 21.25 16H16V21.25C16 21.6642 15.6642 22 15.25 22H8.75C8.33579 22 8 21.6642 8 21.25V16H2.75C2.33579 16 2 15.6642 2 15.25V8.75C2 8.33579 2.33579 8 2.75 8H8V2.75C8 2.33579 8.33579 2 8.75 2H15.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMedicalCross;
